module.exports = __webpack_public_path__ + "static/emerald-6f1aef0b3932eb9f4979823b5c5f2c17.svg";